import React, { useState } from "react";
import PriceSearchButtons from "../components/PriceSearchButtons";
import PriceSearchHeader from "../components/PriceSearchHeader";
import "./styles.scss";
import { useParams, useSearchParams } from "react-router-dom";
import { useConfigureFooter } from "~hooks/useHelpers";
import useCliente from "~/fetchs/useCliente";
import PriceSearchDisclaimer from "../components/PriceSearchDisclaimer";
import { initialPath } from "~misc/paths";
import originControl from "~services/utils/originControl";
import useOnlineStatus from "~hooks/useOnlineStatus";
import useMapaMinaClienteFechado from "~fetchs/useMapaMinaClienteFechado";
import PriceSearchForm from "../components/PriceSearchForm";

const SearchForm = () => {
  const { parameter: idCliente } = useParams();
  const [searchParams] = useSearchParams();
  const origem = searchParams.get("origem");
  const cameFromVisitaView = searchParams.get("cameFromVisitaView");
  const { cliente } = useCliente(idCliente);

  const isOnline = useOnlineStatus();

  const [showButton, setShowButton] = useState(true);

  const { origens, getOrigem } = originControl();

  const { fechadoConsomeBasico, open } = useMapaMinaClienteFechado({
    clienteId: parseInt(idCliente),
    updateData: false,
  });

  useConfigureFooter(
    {
      form: showButton,
      backRoute: `${initialPath}/pesquisa-de-preco/${idCliente}?origem=${origens.editar_pesquisa}${
        searchParams.get("cameFromVisitaView") ? "&cameFromVisitaView=true" : ""
      }`,
      formId: "emissor",
      submitLabel: "Salvar",
      submitVariation: "green",
    },
    [showButton]
  );
  return (
    <>
      <PriceSearchHeader dados={cliente} data-testid="price-search-header" />
      <PriceSearchDisclaimer />
      <PriceSearchButtons
        dados={{
          fechado: fechadoConsomeBasico && fechadoConsomeBasico == "clienteFechado",
          consomeBasico: !(fechadoConsomeBasico && fechadoConsomeBasico == "clienteNaoConsomeBasicos"),
        }}
        open={open}
        setShowButton={setShowButton}
        isOnline={isOnline}
        origem={origem}
        cameFromVisitaView={cameFromVisitaView}
      />
      <PriceSearchForm
        dados={cliente}
        setShowButton={setShowButton}
        origens={origens}
        getOrigem={getOrigem}
        origem={origem}
        cameFromVisitaView={cameFromVisitaView}
      />
    </>
  );
};

export default SearchForm;
